// 时间显示封装
function myTime (t) {
  if (t < 10) {
    t = '0' + t.toString()
  }
  return t
}

// 时间换算 yyyy-mm-dd 字符串
let changeTimeType1 = (str) => {
  if (str !== undefined && str !== null && str !== '') {
    const time = str.replace(/-/g, '/')
    var date = new Date(new Date(time).getTime())
    return date.getFullYear() + '-' + myTime(date.getMonth() + 1) + '-' + myTime(date.getDate())
  } else {
    return ''
  }
}

// 时间换算 yyyy-mm-dd hh:ii:ss 字符串
let changeTimeType2 = (str) => {
  if (str !== undefined && str !== null && str !== '') {
    const time = str.replace(/-/g, '/')
    var date = new Date(new Date(time).getTime())
    return date.getFullYear() + '-' + myTime(date.getMonth() + 1) + '-' + myTime(date.getDate()) + ' ' + myTime(date.getHours()) + ':' + myTime(date.getMinutes()) + ':' + myTime(date.getSeconds())
  } else {
    return ''
  }
}

// 时间换算 hh:ii 字符串
let changeTimeType5 = (str) => {
  if (str !== undefined && str !== null && str !== '') {
    const time = str.replace(/-/g, '/')
    var date = new Date(new Date(time).getTime())
    return myTime(date.getHours()) + ':' + myTime(date.getMinutes())
  } else {
    return ''
  }
}

// 时间换算 yyyy-mm-dd 时间戳
let changeTimeType3 = (str) => {
  if (str !== undefined && str !== null && str !== '') {
    var date = new Date(str)
    return date.getFullYear() + '-' + myTime(date.getMonth() + 1) + '-' + myTime(date.getDate())
  } else {
    return ''
  }
}

// 时间换算 yyyy-mm-dd hh:ii:ss 时间戳
let changeTimeType4 = (str) => {
  if (str !== undefined && str !== null && str !== '') {
    var date = new Date(str)
    return date.getFullYear() + '-' + myTime(date.getMonth() + 1) + '-' + myTime(date.getDate()) + ' ' + myTime(date.getHours()) + ':' + myTime(date.getMinutes()) + ':' + myTime(date.getSeconds())
  } else {
    return ''
  }
}

// 时间换算 hh:ii 时间戳
let changeTimeType6 = (str) => {
  if (str !== undefined && str !== null && str !== '') {
    var date = new Date(str)
    return myTime(date.getHours()) + ':' + myTime(date.getMinutes())
  } else {
    return ''
  }
}

export default {
  changeTimeType1,
  changeTimeType2,
  changeTimeType3,
  changeTimeType4,
  changeTimeType5,
  changeTimeType6
}



// WEBPACK FOOTER //
// ./src/utils/date.js